import { useAuth } from "../auth/AuthProvider";
import { useOrganization } from "../auth/OrganizationProvider";
import { scopedQueryKey } from "../lib/query-scope";

/**
 * All operational read models share an identity and organization cache boundary.
 * RLS remains the authorization boundary; this only prevents client cache reuse.
 */
export function useDataQueryScope() {
  const { user } = useAuth();
  const { activeOrganizationId } = useOrganization();
  const scope = { userId: user?.id ?? null, organizationId: activeOrganizationId };

  return {
    queryKey: (key: readonly unknown[]) => scopedQueryKey(scope, key),
    enabled: Boolean(scope.userId && scope.organizationId),
  };
}
